'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILoading = require('UIComponents/loading/UILoading');

var _UILoading2 = _interopRequireDefault(_UILoading);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _SenderTypePropType = require('../prop-types/SenderTypePropType');

var _SenderTypePropType2 = _interopRequireDefault(_SenderTypePropType);

var _ChatBubble = require('ui-addon-messages/chat-message/ChatBubble');

var _ChatBubble2 = _interopRequireDefault(_ChatBubble);

var _MessageWrapper = require('./MessageWrapper');

var _MessageWrapper2 = _interopRequireDefault(_MessageWrapper);

var _Avatar = require('./Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _SenderName = require('./SenderName');

var _SenderName2 = _interopRequireDefault(_SenderName);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypingIndicator = _react2.default.createClass({
  displayName: 'TypingIndicator',

  propTypes: {
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    currentRole: _SenderTypePropType2.default.isRequired,
    isFirstInGroup: _react.PropTypes.bool.isRequired,
    messageRole: _SenderTypePropType2.default.isRequired,
    use: _react.PropTypes.oneOf((0, _underscore.values)(_ChatBubble.uses)),
    user: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('Visitor'), (0, _RecordPropType2.default)('Responder')])
  },

  renderAvatar: function renderAvatar() {
    var _props = this.props,
        currentRole = _props.currentRole,
        messageRole = _props.messageRole,
        user = _props.user;


    return _react2.default.createElement(_Avatar2.default, {
      responder: user,
      currentRole: currentRole,
      messageRole: messageRole,
      isLastInGroup: true
    });
  },
  renderFooter: function renderFooter() {
    return _react2.default.createElement(
      _Small2.default,
      { className: 'p-top-1' },
      _react2.default.createElement(_SenderName2.default, {
        currentRole: this.props.currentRole,
        messageRole: this.props.messageRole,
        responder: this.props.user
      })
    );
  },
  renderContent: function renderContent() {
    var _props2 = this.props,
        coloring = _props2.coloring,
        isFirstInGroup = _props2.isFirstInGroup;


    var loadingColor = coloring && !coloring.useDefault ? coloring.accentColor : undefined;

    return _react2.default.createElement(
      _ChatBubble2.default,
      {
        className: 'p-x-3 typing-indicator',
        align: _ChatBubble.alignment.LEFT,
        isFirstInGroup: isFirstInGroup,
        isLastInGroup: true,
        use: this.props.use
      },
      _react2.default.createElement(_UILoading2.default, {
        style: { height: 24, fontSize: 8 },
        color: loadingColor,
        grow: false
      })
    );
  },
  render: function render() {
    return _react2.default.createElement(
      _MessageWrapper2.default,
      {
        avatar: this.renderAvatar(),
        footer: this.renderFooter(),
        isOwnMessage: false,
        isLastInGroup: true
      },
      this.renderContent()
    );
  }
});

exports.default = TypingIndicator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/TypingIndicator.js
// module id = 1150
// module chunks = 2 3